/* ═══════════════════════════════════════════════════
   NEWJAISA — FINTECH INDUSTRY PAGE
   File: assets/component-fintech.js
   Namespace: FinPage · No globals · No jQuery
═══════════════════════════════════════════════════ */

'use strict';

var FinPage = (function () {

  function $(id)   { return document.getElementById(id); }
  function $$(sel) { return Array.from(document.querySelectorAll(sel)); }

  /* ── STAGE RATES ────────────────────────── */
  var STAGE_RATES = {
    seed:     { monthly: 0.095 },
    seriesa:  { monthly: 0.052 },
    seriesb:  { monthly: 0.038 },
    cashflow: { monthly: 0.044 }
  };

  var activeStage = 'seriesa';

  /* ── FORMAT INR ─────────────────────────── */
  function fmtINR(n) {
    if (n >= 10000000) return '₹' + (n / 10000000).toFixed(1) + ' Cr';
    if (n >= 100000)   return '₹' + (n / 100000).toFixed(1) + ' L';
    return '₹' + n.toLocaleString('en-IN');
  }

  /* ── BURN RATE CALCULATOR ───────────────── */
  function calcBurn() {
    var seatsEl  = $('ft-bc-seats');
    var deviceEl = $('ft-bc-device');
    if (!seatsEl || !deviceEl) return;

    var seats = parseInt(seatsEl.value)  || 0;
    var price = parseInt(deviceEl.value) || 22000;
    if (seats < 1) return;

    var disc = seats >= 500 ? 0.15 : seats >= 100 ? 0.12 : seats >= 50 ? 0.08 : seats >= 10 ? 0.05 : 0;
    var pricePerUnit = Math.round(price * (1 - disc));
    var totalBuy     = pricePerUnit * seats;
    var newEquiv     = price * 1.95 * seats;
    var saving       = newEquiv - totalBuy;

    var stageData    = STAGE_RATES[activeStage] || STAGE_RATES.seriesa;
    var monthlyLease = Math.round(pricePerUnit * stageData.monthly * seats);

    var buyEl   = $('ft-bcr-buy');
    var leaseEl = $('ft-bcr-lease');
    var saveEl  = $('ft-bcr-save');
    var discEl  = $('ft-bcr-disc');

    if (buyEl)   buyEl.textContent   = fmtINR(totalBuy);
    if (leaseEl) leaseEl.textContent = fmtINR(monthlyLease) + '/mo';
    if (saveEl)  saveEl.textContent  = fmtINR(saving) + ' saved vs new';

    if (discEl) {
      // if (disc > 0) {
      //   discEl.textContent  = '✓ ' + (disc * 100).toFixed(0) + '% volume discount applied';
      //   discEl.style.display = 'block';
      // } else {
      //   discEl.style.display = 'none';
      // }
    }
  }

  /* ── STAGE PILLS ────────────────────────── */
  function initStagePills() {
    $$('.ft-stage-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        $$('.ft-stage-pill').forEach(function (p) { p.classList.remove('ft-on'); });
        pill.classList.add('ft-on');
        activeStage = pill.getAttribute('data-stage') || 'seriesa';
        calcBurn();
      });
    });
  }

  /* ── FAQ ACCORDION ──────────────────────── */
  function initFAQ() {
    $$('.ft-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item   = btn.closest('.ft-faq-item');
        if (!item) return;
        var isOpen = item.classList.contains('open');

        $$('.ft-faq-item.open').forEach(function (i) {
          i.classList.remove('open');
          var q = i.querySelector('.ft-faq-q');
          if (q) q.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── SCROLL REVEAL ──────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.ft-reveal').forEach(function (el) { el.classList.add('ft-vis'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var parent   = entry.target.parentElement;
        var siblings = parent
          ? Array.from(parent.children).filter(function (el) {
              return el.classList.contains('ft-reveal') && !el.classList.contains('ft-vis');
            })
          : [];
        var idx = siblings.indexOf(entry.target);
        setTimeout(function () { entry.target.classList.add('ft-vis'); }, Math.max(0, idx * 80));
        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    $$('.ft-reveal').forEach(function (el) { io.observe(el); });
  }

  /* ── ANCHOR SMOOTH SCROLL ───────────────── */
  function initAnchors() {
    $$('a[href="#ft-cta"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var el = document.getElementById('ft-cta');
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── GUIDE DOWNLOAD PLACEHOLDER ─────────── */
  function initDownloads() {
    var dlBtn = $('ft-dl-guide');
    if (dlBtn) {
      dlBtn.addEventListener('click', function () {
        alert('Downloading: Fintech Industry Guide\n\nContact business@newjaisa.com to receive the full guide.');
      });
    }
  }

  /* ── INIT ───────────────────────────────── */
  function init() {
    initStagePills();

    var seatsEl  = $('ft-bc-seats');
    var deviceEl = $('ft-bc-device');
    if (seatsEl)  seatsEl.addEventListener('input',  calcBurn);
    if (deviceEl) deviceEl.addEventListener('change', calcBurn);
    calcBurn();

    initFAQ();
    initReveal();
    initAnchors();
    initDownloads();
  }

  return { init: init };

})();

document.addEventListener('DOMContentLoaded', function () {
  FinPage.init();
});
